/**
 * @generated SignedSource<<e88be0a0f47ceafecf65f9838fd660e1>>
 * @relayHash c4df84ea0fb09cca4d217d3f3b1e6526
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9dcd3c7b3dba0bc2788ae9ccaa6f4ea9319b527b9306aeb8643830dc382a94fc

import type { ConcreteRequest } from 'relay-runtime';
export type ContentDeleteActionType = "DELETE_DRAFT" | "DELETE_DRAFT_IF_BLANK" | "MOVE_TO_TRASH" | "PURGE_FROM_TRASH" | "%future added value";
export type PageTreeSmartLinkDropMonitorDeleteMutation$variables = {
  action: ContentDeleteActionType;
  contentId: string;
};
export type PageTreeSmartLinkDropMonitorDeleteMutation$data = {
  readonly deleteContent: {
    readonly contentId: string;
  } | null;
};
export type PageTreeSmartLinkDropMonitorDeleteMutation = {
  response: PageTreeSmartLinkDropMonitorDeleteMutation$data;
  variables: PageTreeSmartLinkDropMonitorDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "action",
        "variableName": "action"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "DeleteContentResponsePayload",
    "kind": "LinkedField",
    "name": "deleteContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c4df84ea0fb09cca4d217d3f3b1e6526",
    "id": "9dcd3c7b3dba0bc2788ae9ccaa6f4ea9319b527b9306aeb8643830dc382a94fc",
    "metadata": {},
    "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PageTreeSmartLinkDropMonitorDeleteMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId}}"
  }
};
})();

(node as any).hash = "03dea5e17e424646c6535f7b61c07883";

export default node;
